import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ApiProvider } from "./context/ApiContext";
import { AppProvider } from "./context/AppContext";
import { ProjectProvider } from "./context/ProjectContext";
import { ComponentEditorProvider } from "./context/ComponentEditorContext";
import { DesignProvider } from "./context/DesignContext";
import { ContentProvider } from "./context/ContentContext";
import Home from "./pages/Home";
import AppHome from "./pages/AppHome";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import TwoFactor from "./pages/TwoFactor";
import ForgotPassword from "./pages/ForgotPassword";
import Editor from "./pages/Editor";
import Services from "./pages/Services";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";

// App pages
const Users = () => <div>Users Page</div>;
const Products = () => <div>Products Page</div>;
const Billing = () => <div>Billing Page</div>;
const Invoices = () => <div>Invoices Page</div>;
const Publishing = () => <div>Publishing Page</div>;

const App = () => {
	return (
		<ThemeProvider>
			<AuthProvider>
				<ApiProvider>
					<ProjectProvider>
						<AppProvider>
							<DesignProvider>
								<ContentProvider>
									<ComponentEditorProvider>
										<Router>
											<Routes>
												<Route path="/login" element={<Login />} />
												<Route path="/signup" element={<SignUp />} />
												<Route path="/two-factor" element={<TwoFactor />} />
												<Route path="/forgot-password" element={<ForgotPassword />} />
												<Route
													path="/"
													element={
														<ProtectedRoute>
															<Home />
														</ProtectedRoute>
													}
												/>

												{/* App Routes */}
												<Route
													path="/app/:appId"
													element={
														<ProtectedRoute>
															<AppHome />
														</ProtectedRoute>
													}
												/>
												<Route
													path="/canvas/:appId"
													element={
														<ProtectedRoute>
															<Editor />
														</ProtectedRoute>
													}
												/>
												<Route
													path="/app/:appId/services"
													element={
														<ProtectedRoute>
															<Services />
														</ProtectedRoute>
													}
												/>
												<Route
													path="/app/:appId/finance"
													element={
														<ProtectedRoute>
															<div>Finance Page</div>
														</ProtectedRoute>
													}
												/>
												<Route
													path="/app/:appId/products"
													element={
														<ProtectedRoute>
															<div>Products Page</div>
														</ProtectedRoute>
													}
												/>
												<Route
													path="/app/:appId/settings"
													element={
														<ProtectedRoute>
															<div>Settings Page</div>
														</ProtectedRoute>
													}
												/>

												{/* App Routes */}
												<Route
													path="/:appName/users"
													element={
														<ProtectedRoute>
															<Users />
														</ProtectedRoute>
													}
												/>
												<Route
													path="/:appName/products"
													element={
														<ProtectedRoute>
															<Products />
														</ProtectedRoute>
													}
												/>

												{/* Finance Routes */}
												<Route
													path="/finance/billing"
													element={
														<ProtectedRoute>
															<Billing />
														</ProtectedRoute>
													}
												/>
												<Route
													path="/finance/invoices"
													element={
														<ProtectedRoute>
															<Invoices />
														</ProtectedRoute>
													}
												/>

												{/* Publishing Routes */}
												<Route
													path="/publishing/apple"
													element={
														<ProtectedRoute>
															<Publishing />
														</ProtectedRoute>
													}
												/>

												{/* Fallback */}
												<Route path="*" element={<Navigate to="/" replace />} />
											</Routes>
										</Router>
									</ComponentEditorProvider>
								</ContentProvider>
							</DesignProvider>
						</AppProvider>
					</ProjectProvider>
				</ApiProvider>
			</AuthProvider>
		</ThemeProvider>
	);
};

export default App;
